import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { colombianCities, getAllCities } from '../data/colombia_locations';

export interface City {
  id: number;
  name: string;
  state_id: number;
  code?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor() { }

  /**
   * Obtiene todas las ciudades
   * Usa datos estáticos locales para evitar problemas de integración
   */
  getAllCities(): Observable<City[]> {
    return of(getAllCities());
  }

  /**
   * Obtiene las ciudades de un estado específico
   * Usa datos estáticos locales para evitar problemas de integración
   * @param stateId ID del estado/departamento
   */
  getCitiesByState(stateId: number): Observable<City[]> {
    // Usamos indexación segura con una aserción de tipo para evitar errores
    const cities = (colombianCities as {[key: number]: City[]})[
      stateId
    ] || [];
    return of(cities);
  }
}
